import { ICanNotify } from "../../domain/notifications/ICanNotify";
import { IMessageToDisplay } from "../../domain/notifications/IMessageToDisplay";

export class NotifierPlug implements ICanNotify {
    notify(messageToDisplay: IMessageToDisplay): Promise<any> {
        // To implement
        console.log(messageToDisplay);
        return Promise.resolve();
    }
}
